// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lexend:wght@100..900&family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: Lexend, sans-serif;
}

.form-check .form-check-input {
  background-color: transparent;
  border-color: #233289;
  border-width: 2px;
  cursor: pointer;
}

.form-check .form-check-input:checked {
  background-color: #233289;
}

.form-check label {
  cursor: pointer;
}

#app {
  background: linear-gradient(180deg, rgba(255,207,86,1) 0%, rgba(255,207,86,1) 24%, rgba(255,229,111,1) 61%, rgba(255,247,210,1) 90%, rgba(255,253,243,1) 100%);
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  width: 100%;
}

#content {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 0 auto;
  max-width: 800px;
  position: relative;
  width: 100%;
}

.instructions {
  margin: 2vh 7.5%;
  text-align: center;
}

.instructions a {
  color: #07144C;
}

.loading {
  align-items: center;
  display: flex;
  flex: 1 1;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.scrollable {
  flex: 1 1;
  overflow: auto;
}

.chat {
  display: flex;
  flex-direction: column;
  padding: 5% 7.5% 0 7.5%;
}

.chat a {
  color: #07144C;
  text-decoration: underline;
}

.chat .bookmark {
  background-color: rgba(255, 255, 255, 0.57);
  border-radius: 2vh;
  border-bottom-left-radius: 0;
  color: #07144C;
  margin-bottom: 1rem;
  padding: 5% 7.5%;
  position: relative;
}

.chat .bookmark .delete {
  cursor: pointer;
  position: absolute;
  right: 3%;
  top: 1.5%;
  width: 1rem;
}

.chat .request {
  background-color: rgba(255, 255, 255, 0.57);
  border-radius: 2vh;
  border-bottom-right-radius: 0;
  color: #07144C;
  margin-left: 7.5%;
  padding: 5% 7.5%;
  text-align: right;
}

.chat .response {
  border-bottom: 1px solid rgba(7, 20, 76, 0.2);
  color: #07144C;
  margin: 1rem 0;
}

.chat .response .controls {
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
  margin: 0.5rem 0;
}

.chat .response .controls .left {
  width: 25%;
}

.chat .response .controls .center {
  text-align: center;
  width: 50%;
}

.chat .response .controls .right {
  text-align: right;
  width: 25%;
}

.chat .response .controls img {
  cursor: pointer;
  width: 1.5rem;
}

.chat .response .controls img + img {
  margin-left: 1rem;
}

.chat .response .controls p {
  font-size: 0.875rem;
  margin: 0;
}

.chat .suggestions {
  background-color: #233289;
  border-radius: 2vh;
  color: #fff;
  margin-bottom: 1rem;
  padding: 5% 7.5%;
}

.chat .suggestions .title {
  align-items: center;
  display: flex;
}

.chat .suggestions .title img {
  margin-right: 0.5rem;
  width: 1.5rem;
}

.chat .suggestions .title span {
  font-size: 1.25rem;
  font-weight: bold;
  height: 30px;
}

.chat .suggestions ul { 
  list-style: none;
  margin: 0;
  padding: 0;
}

.chat .suggestions ul li {
  align-items: center;
  display: flex;
  margin-top: 1rem;
}

.chat .suggestions ul li img {
  margin-right: 0.5rem;
  width: 1.5rem;
}

.chat .suggestions ul li span {
  cursor: pointer;
  font-size: 0.875rem;
  text-decoration: underline;
}

.chat .wmde-markdown {
  background: transparent;
  color: #07144C;
  line-height: normal;
}

.text-input {
  align-items: center;
  display: flex;
  height: 12vh;
  justify-content: center;
  position: relative;
}

.text-input img.icon-chat {
  height: 4vh;
  left: 3%;
  position: absolute;
}

.text-input img.icon-submit {
  cursor: pointer;
  height: 6vh;
  right: 3%;
  position: absolute;
}

.text-input input {
  background-color: rgba(255, 255, 255, 0.86);
  border: 1px solid rgba(35, 50, 137, 0.5);
  border-radius: 4vh;
  box-sizing: border-box;
  font-size: 1rem;
  height: 8vh;
  padding: 0 20% 0 15%;
  width: 100%;
}

.text-input input::placeholder {
  color: rgba(35, 50, 137, 0.66);
}

#filters {
  align-items: center;
  display: flex;
}

#filters .filter {
  border-bottom: 2px solid transparent;
  margin-right: 2rem;
}

#filters .filter.active {
  border-bottom-color: #233289;
}

#filters .filter img {
  height: 1.25rem;
}

#pager {
  align-items: center;
  display: flex;
  justify-content: center;
}

#pager .page {
  background-color: rgba(35, 50, 137, 0.5);
  border-radius: 50%;
  cursor: pointer;
  height: 0.67rem;
  width: 0.67rem;
}

#pager .page:not(:last-of-type) {
  margin-right: 1.25rem;
}

#pager .page.active {
  background-color: #233289;
}

.popup-overlay {
  align-items: center;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  inset: 0;
  justify-content: center;
  position: absolute;
}

.popup {
  background-color: rgba(255, 207, 86, 1);
  border-radius: 2vh;
  box-shadow: 0 3.5px 6px rgba(0, 0, 0, 0.05);
  margin: 0 5%;
  padding: 3vh;
  text-align: center;
}

.popup a {
  color: #07144C;
}

#error-container {
  cursor: pointer;
}

#error {
  width: 100%;
}

#error span {
  color: #ff144C;
  font-size: 1.5rem;
}

.actions {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.action {
  border-radius: 2vh;
  color: #fff;
  cursor: pointer;
  padding: 0.5rem 2rem;
}

.action:not(:first-of-type) {
  margin-left: 1rem;
}

.action.action-primary {
  background-color: #07144C;
}

.action.action-secondary {
  background-color: rgb(108, 117, 125);
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8JAA8J;EAC9J,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;AACb;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;EAC7C,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,wCAAwC;EACxC,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,2CAA2C;EAC3C,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Lexend:wght@100..900&family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');\n\n* {\n  font-family: Lexend, sans-serif;\n}\n\n.form-check .form-check-input {\n  background-color: transparent;\n  border-color: #233289;\n  border-width: 2px;\n  cursor: pointer;\n}\n\n.form-check .form-check-input:checked {\n  background-color: #233289;\n}\n\n.form-check label {\n  cursor: pointer;\n}\n\n#app {\n  background: linear-gradient(180deg, rgba(255,207,86,1) 0%, rgba(255,207,86,1) 24%, rgba(255,229,111,1) 61%, rgba(255,247,210,1) 90%, rgba(255,253,243,1) 100%);\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  position: relative;\n  width: 100%;\n}\n\n#content {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  margin: 0 auto;\n  max-width: 800px;\n  position: relative;\n  width: 100%;\n}\n\n.instructions {\n  margin: 2vh 7.5%;\n  text-align: center;\n}\n\n.instructions a {\n  color: #07144C;\n}\n\n.loading {\n  align-items: center;\n  display: flex;\n  flex: 1;\n  height: 100%;\n  justify-content: center;\n  width: 100%;\n}\n\n.scrollable {\n  flex: 1;\n  overflow: auto;\n}\n\n.chat {\n  display: flex;\n  flex-direction: column;\n  padding: 5% 7.5% 0 7.5%;\n}\n\n.chat a {\n  color: #07144C;\n  text-decoration: underline;\n}\n\n.chat .bookmark {\n  background-color: rgba(255, 255, 255, 0.57);\n  border-radius: 2vh;\n  border-bottom-left-radius: 0;\n  color: #07144C;\n  margin-bottom: 1rem;\n  padding: 5% 7.5%;\n  position: relative;\n}\n\n.chat .bookmark .delete {\n  cursor: pointer;\n  position: absolute;\n  right: 3%;\n  top: 1.5%;\n  width: 1rem;\n}\n\n.chat .request {\n  background-color: rgba(255, 255, 255, 0.57);\n  border-radius: 2vh;\n  border-bottom-right-radius: 0;\n  color: #07144C;\n  margin-left: 7.5%;\n  padding: 5% 7.5%;\n  text-align: right;\n}\n\n.chat .response {\n  border-bottom: 1px solid rgba(7, 20, 76, 0.2);\n  color: #07144C;\n  margin: 1rem 0;\n}\n\n.chat .response .controls {\n  align-items: flex-end;\n  display: flex;\n  justify-content: space-between;\n  margin: 0.5rem 0;\n}\n\n.chat .response .controls .left {\n  width: 25%;\n}\n\n.chat .response .controls .center {\n  text-align: center;\n  width: 50%;\n}\n\n.chat .response .controls .right {\n  text-align: right;\n  width: 25%;\n}\n\n.chat .response .controls img {\n  cursor: pointer;\n  width: 1.5rem;\n}\n\n.chat .response .controls img + img {\n  margin-left: 1rem;\n}\n\n.chat .response .controls p {\n  font-size: 0.875rem;\n  margin: 0;\n}\n\n.chat .suggestions {\n  background-color: #233289;\n  border-radius: 2vh;\n  color: #fff;\n  margin-bottom: 1rem;\n  padding: 5% 7.5%;\n}\n\n.chat .suggestions .title {\n  align-items: center;\n  display: flex;\n}\n\n.chat .suggestions .title img {\n  margin-right: 0.5rem;\n  width: 1.5rem;\n}\n\n.chat .suggestions .title span {\n  font-size: 1.25rem;\n  font-weight: bold;\n  height: 30px;\n}\n\n.chat .suggestions ul { \n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.chat .suggestions ul li {\n  align-items: center;\n  display: flex;\n  margin-top: 1rem;\n}\n\n.chat .suggestions ul li img {\n  margin-right: 0.5rem;\n  width: 1.5rem;\n}\n\n.chat .suggestions ul li span {\n  cursor: pointer;\n  font-size: 0.875rem;\n  text-decoration: underline;\n}\n\n.chat .wmde-markdown {\n  background: transparent;\n  color: #07144C;\n  line-height: normal;\n}\n\n.text-input {\n  align-items: center;\n  display: flex;\n  height: 12vh;\n  justify-content: center;\n  position: relative;\n}\n\n.text-input img.icon-chat {\n  height: 4vh;\n  left: 3%;\n  position: absolute;\n}\n\n.text-input img.icon-submit {\n  cursor: pointer;\n  height: 6vh;\n  right: 3%;\n  position: absolute;\n}\n\n.text-input input {\n  background-color: rgba(255, 255, 255, 0.86);\n  border: 1px solid rgba(35, 50, 137, 0.5);\n  border-radius: 4vh;\n  box-sizing: border-box;\n  font-size: 1rem;\n  height: 8vh;\n  padding: 0 20% 0 15%;\n  width: 100%;\n}\n\n.text-input input::placeholder {\n  color: rgba(35, 50, 137, 0.66);\n}\n\n#filters {\n  align-items: center;\n  display: flex;\n}\n\n#filters .filter {\n  border-bottom: 2px solid transparent;\n  margin-right: 2rem;\n}\n\n#filters .filter.active {\n  border-bottom-color: #233289;\n}\n\n#filters .filter img {\n  height: 1.25rem;\n}\n\n#pager {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n\n#pager .page {\n  background-color: rgba(35, 50, 137, 0.5);\n  border-radius: 50%;\n  cursor: pointer;\n  height: 0.67rem;\n  width: 0.67rem;\n}\n\n#pager .page:not(:last-of-type) {\n  margin-right: 1.25rem;\n}\n\n#pager .page.active {\n  background-color: #233289;\n}\n\n.popup-overlay {\n  align-items: center;\n  background: rgba(0, 0, 0, 0.75);\n  display: flex;\n  inset: 0;\n  justify-content: center;\n  position: absolute;\n}\n\n.popup {\n  background-color: rgba(255, 207, 86, 1);\n  border-radius: 2vh;\n  box-shadow: 0 3.5px 6px rgba(0, 0, 0, 0.05);\n  margin: 0 5%;\n  padding: 3vh;\n  text-align: center;\n}\n\n.popup a {\n  color: #07144C;\n}\n\n#error-container {\n  cursor: pointer;\n}\n\n#error {\n  width: 100%;\n}\n\n#error span {\n  color: #ff144C;\n  font-size: 1.5rem;\n}\n\n.actions {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  margin-top: 1rem;\n}\n\n.action {\n  border-radius: 2vh;\n  color: #fff;\n  cursor: pointer;\n  padding: 0.5rem 2rem;\n}\n\n.action:not(:first-of-type) {\n  margin-left: 1rem;\n}\n\n.action.action-primary {\n  background-color: #07144C;\n}\n\n.action.action-secondary {\n  background-color: rgb(108, 117, 125);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
